// extracted by mini-css-extract-plugin
export default {"container":"AddSchoolMode_container__4Mrok","spinner":"AddSchoolMode_spinner__gYFqG","spin":"AddSchoolMode_spin__mBKO8"};